/* workspace-admin/index — Workspace Layer routes.
   Directory is standalone; Detail/Membership/Modules/AuditLog/Settings
   render inside the workspace console shell. Guards applied per-capability. */
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { usePlatformData } from '../platform/platformStore';
import { RequireRole } from '../rbac/guards';
import WorkspaceConsoleLayout from './WorkspaceConsoleLayout';
import Directory from './Directory';
import Detail from './Detail';
import Membership from './Membership';
import Settings from './Settings';
import Modules from './Modules';
import AuditLog from './AuditLog';
import CustomFieldsAdmin from './CustomFieldsAdmin';
import CustomObjectsAdmin from './CustomObjectsAdmin';

export default function WorkspaceAdminRoutes() {
  const data = usePlatformData();
  return (
    <Routes>
      <Route index element={<RequireRole action="workspace.view"><Directory data={data} /></RequireRole>} />
      <Route path=":wsId" element={
        <RequireRole action="membership.view"><WorkspaceConsoleLayout data={data}><Detail data={data} /></WorkspaceConsoleLayout></RequireRole>
      } />
      <Route path=":wsId/members" element={
        <RequireRole action="membership.view"><WorkspaceConsoleLayout data={data}><Membership data={data} /></WorkspaceConsoleLayout></RequireRole>
      } />
      <Route path=":wsId/modules" element={
        <RequireRole action="workspace.settings"><WorkspaceConsoleLayout data={data}><Modules data={data} /></WorkspaceConsoleLayout></RequireRole>
      } />
      <Route path=":wsId/audit" element={
        <RequireRole action="workspace.settings"><WorkspaceConsoleLayout data={data}><AuditLog data={data} /></WorkspaceConsoleLayout></RequireRole>
      } />
      <Route path=":wsId/settings" element={
        <RequireRole action="workspace.settings"><WorkspaceConsoleLayout data={data}><Settings data={data} /></WorkspaceConsoleLayout></RequireRole>
      } />
      <Route path=":wsId/customization/fields" element={
        <RequireRole action="crm.manage"><WorkspaceConsoleLayout data={data}><CustomFieldsAdmin data={data} /></WorkspaceConsoleLayout></RequireRole>
      } />
      <Route path=":wsId/customization/objects" element={
        <RequireRole action="crm.manage"><WorkspaceConsoleLayout data={data}><CustomObjectsAdmin data={data} /></WorkspaceConsoleLayout></RequireRole>
      } />
    </Routes>
  );
}
